import { render } from "./GeneratedTicketBet.vue?vue&type=template&id=6f54fa1b"
import script from "./GeneratedTicketBet.vue?vue&type=script&lang=js"
export * from "./GeneratedTicketBet.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__